module.exports = __webpack_public_path__ + "static/media/why-img2m.04cbf566.png";